import React, { useEffect, useMemo, useState } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import classnames from 'classnames'
import { message } from 'antd'
import { Dropdown } from 'meinian-package/src/baseComponent'
import Icon from 'meinian-package/src/component/icon'
import { NewSearch } from 'meinian-package/src/baseComponent/input'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import { getMeinianFilters } from 'common/localData'
import { INDUSTRY } from 'meinian-package/src/component/enum'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import styles from './index.module.less'

const highlight = (value, searchKey) => value.replace(new RegExp(`(${searchKey})`, 'g'), '<span class="h">$1</span>')

export default ({
  disableOption,
  onChange,
  value = {},
  disabled,
  platformId,
  noneText = '不限',
  industry = INDUSTRY.CLOTHING
}) => {
  const meinianFilters = getMeinianFilters()
  const [visible, setVisible] = useState(false)
  const [currentOptions, setCurrentOptions] = useState([])
  const [searchKey, setSearchKey] = useState('')
  const [childrenOptions, setChildrenOptions] = useState(null)
  const [rootHoverOptions, setRootHoverOptions] = useState()

  const _options = {
    [INDUSTRY.CLOTHING]: meinianFilters?.find(m => m.itemName === `${INDUSTRY.CLOTHING}设计要素`)?.itemTreeValue,
    [INDUSTRY.SHOES]: meinianFilters?.find(m => m.itemName === `${INDUSTRY.SHOES}设计要素`)?.itemTreeValue
  }
  const miniRight = currentOptions && currentOptions.itemTreeValue?.children?.every(m => m.children.length === 0)
  const optionsByIndustry = _options[industry]?.children

  useEffect(() => {
    const _curOptions = cloneDeep(_options[industry])
    setCurrentOptions(_curOptions ? _curOptions?.children?.filter(i => i.itemTreeValue).find(m => m.itemName !== disableOption) : [])
  }, [industry])

  const searchList = useMemo(() => {
    const res = []
    currentOptions?.itemTreeValue?.children?.forEach((m) => {
      if (m.name.includes(searchKey)) {
        res.push({ name: highlight(m.name, searchKey), value: { root: m.name, child: null } })
        res.push(...m.children.map(k => ({
          name: highlight(`${m.name}/${k.name}`, searchKey),
          value: { root: m.name, child: k.name }
        })))
        return
      }
      m.children.forEach((k) => {
        if (k.name.includes(searchKey)) {
          res.push({
            name: highlight(`${m.name}/${k.name}`, searchKey),
            value: { root: m.name, child: k.name }
          })
        }
      })
    })
    return res
  }, [currentOptions])

  const onValuesChange = (itemName, itemValue) => {
    const newValues = cloneDeep(value)
    if (isEqual(newValues[itemName], itemValue)) {
      delete newValues[itemName]
    } else {
      newValues[itemName] = itemValue
    }
    onChange?.(newValues)
    setVisible(false)
  }

  const renderColor = () => {
    const { itemTreeValue: { children = [] }, itemName } = currentOptions
    const itemValue = value[itemName]
    return <ul className="select-color-panel">
      {
        children.map(m => (
          <div key={m.name} className="select-color-pane-item">
            <li
              className={classnames({ active: itemValue?.root === m.name })}
              onClick={() => onValuesChange(itemName, { root: m.name, child: null })}
              style={{ backgroundColor: m.averageHue }}
            >
              {
                itemValue?.root === m.name && <div className="select-color-icon-wrap"><Icon className="select-color-icon" type="m-xiaoyan" /></div>
              }
            </li>
            <div>{m.name}</div>
          </div>))
      }
    </ul>
  }
  const renderItems = () => {
    const { itemTreeValue: { children = [] }, itemName } = currentOptions
    const itemValue = value[itemName] || {}
    return <div className="select-right-wrap-item">
      {children.map(m => <div
        className={classnames('select-right-item', { active: itemValue.root === m.name })}
        key={m.name}
        onClick={() => onValuesChange(itemName, { root: m.name, child: null })}
      >{m.name}</div>)}
    </div>
  }
  const renderSearchItems = () => {
    const children = currentOptions.itemTreeValue?.children || []
    const { itemName } = currentOptions
    const itemValue = value?.[itemName] || {}
    let list = null
    if (searchKey.length) {
      list = searchList.length
        ? <div className="meinian-select-list-cascade">
          <div className="list">
            {searchList.map(m => <div
              className={classnames('list-item')}
              key={m.value}
              onClick={() => onValuesChange(itemName, m.value)}
              dangerouslySetInnerHTML={{ __html: m.name }}
            />)}</div>
        </div>
        : <div className="empty">暂无相关设计要素</div>
    } else {
      list = <div className="meinian-select-list-cascade">
        <div className="list list-left">
          {children.map(m => <div
            className={classnames('list-item', { active: m.children === childrenOptions || (m.name === itemValue.root && !itemValue.child) })}
            onClick={() => onValuesChange(itemName, { root: m.name, child: null })}
            onMouseEnter={() => {
              setChildrenOptions(m.children)
              setRootHoverOptions(m)
            }}
          >
            {m.name}
            <Icon type="m-Vxing_you" />
          </div>)}
        </div>
        <div className="list">
          {childrenOptions && childrenOptions.map(m => <div
            className={classnames('list-item', { active: rootHoverOptions.name === itemValue.root && itemValue.child === m.name })}
            onClick={() => onValuesChange(itemName, { root: rootHoverOptions.name, child: m.name })}
            active={rootHoverOptions.name === itemValue.root && itemValue.child === m.name}
          >{m.name}</div>)}
        </div>
      </div>
    }
    return <div className="filter-items-search">
      <header>
        <NewSearch
          wrapStyle={{ borderRadius: '6px' }}
          onChange={(val) => setSearchKey(val)}
          placeholder="请输入关键字搜索"
        />
      </header>
      <main>
        {list}
      </main>
    </div>
  }
  const renderMenuItems = () => {
    let content = null
    if (currentOptions.itemName === '色系') { // 颜色单独渲染
      content = renderColor()
    } else if (miniRight) { // 只有一级类目单独渲染
      content = renderItems()
    } else {
      content = renderSearchItems()
    }
    return content
  }

  const renderItemText = (itemValue) => {
    if (!itemValue) return <span className="value">{noneText}</span>
    const { root, child } = itemValue
    if (!root && !child) return <span className="value">{noneText}</span>
    if (root && !child) return <span className="value active">{root}</span>
    return <span className="value active">{`${root}-${child}`}</span>
  }

  const onShowOptions = (__options) => {
    setCurrentOptions(cloneDeep(__options))
    setSearchKey('')
    setChildrenOptions(null)
    setRootHoverOptions(null)
  }

  const menu = <div className={classnames(styles['meinian-select-element'])} onClick={e => e.stopPropagation()}>
    <div className="select-left">
      <div style={{ flex: 1 }}>
        {optionsByIndustry?.map((m) => {
          const _disabled = disableOption === m.itemName
          if (disableOption === m.itemName) {
            return null
          }
          return <div
            key={m.id}
            className={classnames('select-left-item', { active: value[m.itemName] || currentOptions === m })}
            onMouseEnter={() => {
              !_disabled && onShowOptions(m)
            }}
          >
            <div>{m.itemName}</div>
            <div className="df-center-center">
              {renderItemText(value[m.itemName], noneText)}
              <Icon type="m-Vxing_you" style={{ color: 'var(--m-text-2)' }} />
            </div>
          </div>
        })}
      </div>
    </div>
    <div className={classnames('select-right', { show: !!currentOptions })}>{renderMenuItems()} </div>
  </div>

  if (industry === INDUSTRY.SHOES
  && (platformId === PLATFORM_VALUE.INS || platformId === PLATFORM_VALUE.WEIBO || platformId === PLATFORM_VALUE.UPLOAD)) {
    return null
  }

  return <Dropdown
    open={visible}
    placement="bottomLeft"
    trigger={['click']}
    overlayClassName=""
    overlay={menu}
    onOpenChange={(vis) => setVisible(vis)}
    disabled={disabled}
    onClick={() => disabled && message.info('请先选择品类筛选项，且品类筛选项不可选为不限哦')}
  >
    <span className={classnames(styles.filter, 'dropDownClearIcon', { clear: Object.keys(value).length })} style={{ color: disabled && 'var(--m-text-4)' }}>
      <span>设计要素：</span>
      <DropDownClearIcon
        visible={visible}
        onClear={() => {
          onChange({})
          setVisible(false)
        }}
      >
        {
      Object.keys(value).length ? <div className="filterLabelValueNum">
        { Object.keys(value).length}
      </div> : <span className="filterLabelValueAllowClearText">
        不限
      </span>
    }
      </DropDownClearIcon>
    </span>
  </Dropdown>
}
